import React, { useEffect, useState, useMemo, useRef } from "react"
import {  useParams } from "react-router-dom"
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import LineReport from "./LineReport";
import StatCard from "./Card";
import { MessageSquareText, RadioTowerIcon, TicketCheck, Users } from "lucide-react";
import ReactTooltip from 'react-tooltip';
import styles from "./index.module.css";
import stylesReport from "./report.module.css";
import LoadingModal from "./Unit/LoadingModal";

function LineModal(props) {
  return (
    <>
      <Modal
      size="xl"
       {...props}
       fullscreen
       aria-labelledby="contained-modal-title-vcenter"
       centered
       backdrop="static"
       keyboard={false}
      >
        <Modal.Header className="justify-content-end">
          <Button variant="light right" onClick={props.onHide}>
          <i className="fa-solid fa-xmark purple"></i>
        </Button>
        </Modal.Header>
        <Modal.Body>
          <LineReport />
        </Modal.Body>
      </Modal>
    </>
  );
}
export default function Line() {
     const {t, i18n} = useTranslation()
     const language = i18n.language
     const { lang = i18n.language || "en" } = useParams();
     const [loading, setLoading] = useState(false)
     const [visible, setVisible] = useState(false)
     const [lineData, setLineData] = useState([])
     const [lineCouponDTB, setLineCouponDTB] = useState()
     const [totalNight, setTotalNight] = useState(0)
     const [lineCouponRP, setLineCouponRP] = useState()

const [year, setYear] = useState(() => {
  return dayjs().year();
})

const [month, setMonth] = useState(() => {
  return dayjs().month() + 1;
})  


 const getLineCouponDTBData = async () => {
    setLoading(true)
    try {
      const response = await fetch(`https://database.azumayareport.com/booking/all/get_data_by_request_on_other/${year}-${month}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          value: "LINE"
        })
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const responseData = await response.json();
      if(responseData){
        setLoading(false) 
        setLineCouponDTB(responseData)
      }

    } catch (error) {
      console.error('Error:', error);
        setLoading(false) 

  }
}; 

 const getLineCouponRPData = async () => {
        setLoading(true)

    try {
      const response = await fetch(`https://azumayareport.com/report/take_data_daily_report_month/${year}-0${month}/all`, {
        method: 'GET',
        headers: {
          'Content-Type': 'appication/json',
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const responseData = await response.json();
      if(responseData){
        setLoading(false)
        setLineCouponRP(responseData)
       
      }

    } catch (error) {
      console.error('Error:', error);
           setLoading(false)
  }
};

    useEffect(() => {
    if (!month || !year) return;

    setLoading(true)

    Promise.all([
    getLineCouponDTBData(),
    getLineCouponRPData()
    ]).finally(() => {
      setLoading(false)
    });

  }, [month, year]);

  useEffect(() => {
    if(lineCouponDTB && lineCouponDTB.length > 0){
      const total = lineCouponDTB.reduce((sum, item) => {
        return sum + (item.totalNight || 0);
      }, 0);
      setTotalNight(total)
    }}, [lineCouponDTB])
    
        const getLineData = async () => {
          setLoading(true)
          try {
            const response = await fetch(`/api/control/235f1fd3-af1f-4959-a06b-40b6320ee501/${year}-${String(month).padStart(2, "0")}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
            
            });
            
            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(errorText);
}
            const responseData = await response.json();
            setLineData(responseData)
          } 
          catch (error) {
            console.error('Error:', error);
            setLineData([])
          }
      }

      useEffect(() => {
       getLineData()
      },[month, year])

      useEffect(() => {
       getLineData()
      },[ month, year])

        const countLineStats = (data, metricKey) => {
          if (!Array.isArray(data) || !data.length) return 0;

          return data.reduce((sum, item) => {
            const value = Number(item?.lineData?.[metricKey] || 0);
            return sum + value;
          }, 0);
        };
        const message_delivered = countLineStats( lineData, "message_delivered" )

        const countLineBroadcastStats = (data, metricName, metricKey) => {
                        if (!Array.isArray(data) || !data.length) return 0

                        return data.reduce((weekSum, item) => {
                        const list = item?.lineData?.[metricName] || []

                        if (!Array.isArray(list)) return weekSum

                        const sumPerWeek = list.reduce((sum, obj) => {
                            return sum + Number(obj?.[metricKey] || 0)
                        }, 0)

                        return weekSum + sumPerWeek
                        }, 0)
            }
        const broadCast_delivered = countLineBroadcastStats( lineData, "broadcast","delivered" )
        const broadCast_openCount = countLineBroadcastStats( lineData, "broadcast","openCount" )
        const coupon_numberOfUse = countLineBroadcastStats( lineData, "coupon","numberOfUse" )
        
        const CheckBranchName = (name) => {
          switch(name) {
            case 1: return "Thai Van Lung 1";
            case 3: return "Hai Ba Trung 1";
            case 4: return "Le Thanh Ton";
            case 7: return "Da Nang";
            case 8: return "Kim Ma 2";
            case 9: return "Thai Van Lung 2";
            case 11: return "Phnom Penh";
            case 12: return "Linh Lang";
            case 13: return "Hai Phong";
            case 15: return "Kim Ma 3";
            case 16: return "Dao Tan"
            default: return name
          }
        }

        const CheckMonth = (month) => {
          switch (month) {
            case 'Month 1': return "January";
            case 'Month 2': return "February";
            case 'Month 3': return "March";
            case 'Month 4': return "April";
            case 'Month 5': return "May";
            case 'Month 6': return "June";
            case 'Month 7': return "July";
            case 'Month 8': return "August";
            case 'Month 9': return "September";
            case 'Month 10': return "October";
            case 'Month 11': return "November";
            case 'Month 12': return "December";
            default: return month
          }
        }    
    return (
<div>
   {loading && (
            <LoadingModal />
            )}
  <ReactTooltip id = 'marketing' style={{
                       fontSize: 20,
                       maxWidth: 400,
                       whiteSpace: "pre-line",
                       backgroundColor: "#000",
                       borderRadius: 10,
                       zIndex: 99999
                     }}/>
       
      <div style={{ padding: 20, backgroundColor:"#fff", marginTop: 20 }}>
          <div className="d-flex ml-5 align-items-center" style={{marginTop:30}}>
             <div style={{marginRight: 10, width: 'fit-content'}}>
                <select className={styles.contentBookingBranchSelect} value={year} onChange={(e) => setYear(Number(e.target.value))}>
                {[2024, 2025, 2026, 2027].map(y => (
                  <option key={y} value={y}>{y}</option>
                ))}
              </select>
            </div>
             <div style={{marginRight: 10, width: 'fit-content'}}>
             <select
             className={styles.contentBookingBranchSelect}
              value={month}
              onChange={(e) => setMonth(Number(e.target.value))}
            >
              {Array.from({ length: 12 }).map((_, i) => (
                <option key={i + 1} value={i + 1}>
                  {CheckMonth(`Month ${i+1}`)}
                </option>
              ))}
            </select>
            </div>
          </div>

            <LineModal
                   show = {visible}
                   onHide = {()=> setVisible(false)}/>
                   <div className="d-flex align-items-center" style={{marginTop: 20}}>
            <img src="https://cdn-icons-png.flaticon.com/512/3536/3536785.png" alt="Google Ads" style={{width: 60, height: 60, marginLeft: 30}}/>
        <div style={{fontSize: 60, fontWeight: 'bold', textAlign: 'left', marginLeft: 10}} onClick={() => setVisible(true)}>Line Report</div>
        </div>
        <div style={{fontSize: 50, fontWeight: 'bold', textAlign: 'left', marginLeft: 30, marginTop: 10}}>Overall</div>
            <div className="container-fluid" >
      <div className="row">
        <div className="col-md-3 mb-4">
               <div className={stylesReport.cardWrapper} data-tip={t('marketing.line.message_delivered')} data-for="marketing">
                          <StatCard
                            height={320}
                            fontTitle={40}
                            fontValue={60}
                            title="Message Delivered"
                            value={Intl.NumberFormat('de-DE').format(message_delivered)}
                            icon={<MessageSquareText size={20} color="#06C755" />}
                            gradientFrom="#06C755"
                            gradientTo="#00B900"
                          />
                    </div>
        </div>
          <div className="col-md-3 mb-4">
            <div className={stylesReport.cardWrapper} data-tip={t('marketing.line.broadcast_delivered')} data-for="marketing">
                          <StatCard
                            height={320}
                            fontTitle={40}
                            fontValue={60}
                            title="Broadcast Delivered"
                            value={Intl.NumberFormat('de-DE').format(broadCast_delivered)}
                            icon={<RadioTowerIcon size={20} color="#06C755" />}
                            gradientFrom="#06C755"
                            gradientTo="#00B900"
                          />
                    </div>
        </div>
           <div className="col-md-3 mb-4">
           <div className={stylesReport.cardWrapper} data-tip={t('marketing.line.broadcast_open')} data-for="marketing">
                          <StatCard
                            height={320}
                            fontTitle={40}
                            fontValue={60}
                            title="Broadcast Open"
                            value={Intl.NumberFormat('de-DE').format(broadCast_openCount)}
                            icon={<RadioTowerIcon size={20} color="#06C755" />}
                            gradientFrom="#06C755"
                            gradientTo="#00B900"
                          />
                    </div>
        </div>
           <div className="col-md-3 mb-4">
            <div className={stylesReport.cardWrapper} data-tip={t('marketing.line.coupon_used')} data-for="marketing">
                          <StatCard
                            height={320}
                            fontTitle={40}
                            fontValue={60}
                            title="Coupon Used"
                            value={Intl.NumberFormat('de-DE').format(coupon_numberOfUse)}
                            icon={<TicketCheck size={20} color="#06C755" />}
                            gradientFrom="#06C755"
                            gradientTo="#00B900"
                          />
                    </div>
        </div>
         <div className="col-md-3 mb-4">
            <div className={stylesReport.cardWrapper} data-tip={t('marketing.line.coupon_usedDTB')} data-for="marketing">
                          <StatCard
                            height={320}
                            fontTitle={40}
                            fontValue={60}
                            title="Total Night Used"
                            value={Intl.NumberFormat('de-DE').format(totalNight)}
                            icon={<TicketCheck size={20} color="#06C755" />}
                            gradientFrom="#06C755"
                            gradientTo="#00B900"
                          />
                    </div>
        </div>
         <div className="col-md-3 mb-4">
            <div className={stylesReport.cardWrapper} data-tip={t('marketing.line.coupon_usedRPMS')} data-for="marketing">
                          <StatCard
                            height={320}
                            fontTitle={40}
                            fontValue={60}
                            title="Massage Used"
                            value={Intl.NumberFormat('de-DE').format(lineCouponRP?.result[0]?.massageLine)}
                            icon={<TicketCheck size={20} color="#06C755" />}
                            gradientFrom="#06C755"
                            gradientTo="#00B900"
                          />
                    </div>
        </div>
         <div className="col-md-3 mb-4">
            <div className={stylesReport.cardWrapper} data-tip={t('marketing.line.coupon_usedRPR')} data-for="marketing">
                          <StatCard
                            height={320}
                            fontTitle={40}
                            fontValue={60}
                            title="Room Used"
                            value={Intl.NumberFormat('de-DE').format(lineCouponRP?.result[0]?.roomLine)}
                            icon={<TicketCheck size={20} color="#06C755" />}
                            gradientFrom="#06C755"
                            gradientTo="#00B900"
                          />
                    </div>
        </div>
        <div className="col-md-3 mb-4">
            <div className={stylesReport.cardWrapper} data-tip={t('marketing.line.coupon_usedRPRT')} data-for="marketing">
                          <StatCard
                            height={320}
                            fontTitle={40}
                            fontValue={60}
                            title="Rotenburo Used"
                            value={Intl.NumberFormat('de-DE').format(lineCouponRP?.result[0]?.rotenLine)}
                            icon={<TicketCheck size={20} color="#06C755" />}
                            gradientFrom="#06C755"
                            gradientTo="#00B900"
                          />
                    </div>
        </div>
      </div>
    </div>
       <div style={{fontSize: 50, fontWeight: 'bold', textAlign: 'left', marginLeft: 30, marginTop: 10}}>Detail</div>
                {lineData && (
            <div className={styles.lineReport}>
                <div className={[styles.lineSummary]}>
                <div style={{fontSize: 30, textAlign: 'left', marginLeft: 30,marginTop: 20}}>📩 Delivered: {lineData[0]?.lineData?.message_delivered}</div>
                <div style={{fontSize: 30, textAlign: 'left', marginLeft: 30,marginTop: 10}}>👤 Friend Added: {lineData[0]?.lineData?.friend_added}</div>
                <div style={{fontSize: 30, textAlign: 'left', marginLeft: 30,marginTop: 10}}>🎯 Target Reach: {lineData[0]?.lineData?.target_reach}</div>
                </div>
                 <div style={{ overflowX: "auto", width: "100%" }}>
                  <table border="1" style={{ marginTop: 20, width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr>
                        <th style={thStyle}>No.</th>
                        <th style={thStyle}>Branch</th>
                        <th style={thStyle}>Total Booking Used</th>
                        <th style={thStyle}>Total Night Used</th>
                      </tr>
                    </thead>
                    <tbody>
                      {lineCouponDTB?.map((row, idx) => (
                          <tr key={idx} style={{backgroundColor: idx % 2 == 0 ? "#fff" : "#E6E6E6"}} 
                          >
                            <td style={tdStyle}>{idx+1}</td>
                            <td style={tdStyle}>{CheckBranchName(row.branch)}</td>
                            <td style={tdStyle}>{row.totalBooking}</td>
                            <td style={tdStyle}>{row.totalNight}</td>
                          </tr>
                          )
                      )}
                    </tbody>
                  </table>
                </div>  
                <div style={{fontSize: 40, fontWeight: 'bold', textAlign: 'left', marginLeft: 30, marginTop: 10}}>Broadcast</div>
                  <div style={{ overflowX: "auto" }}>
                  <table style={tableStyle}>
                    <thead>
                      <tr>
                        <th style={thStyle}>No.</th>
                        <th style={thStyle}>ID</th>
                        <th style={thStyle}>Date</th>
                        <th style={thStyle}>Broadcast Name</th>
                         <th style={{...thStyle, backgroundColor:"#DB4437"}}>
                          <div className="d-flex justify-content-between align-items-center">
                            <span>Delivered</span>
                            <div className="d-flex flex-column">
                              <button
                                className="btn-sort"
                                // onClick={() => setSortType("impressions-asc")}
                                 style={{backgroundColor: 'transparent', border: 'none', height: 10}}
                              >
                                <i className="fa-solid fa-caret-up" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                              <button
                                className="btn-sort"
                                // onClick={() => setSortType("impressions-desc")}
                                style={{backgroundColor: 'transparent', border: 'none', height: 10, marginBottom: 10}}

                              >
                                <i className="fa-solid fa-caret-down" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                            </div>
                          </div>
                        </th>
                       <th style={{...thStyle, backgroundColor:"#F4B400"}}>
                          <div className="d-flex justify-content-between align-items-center">
                            <span>Open</span>
                            <div className="d-flex flex-column ml-1">
                              <button
                                className="btn-sort"
                                // onClick={() => setSortType("clicks-asc")}
                                 style={{backgroundColor: 'transparent', border: 'none', height: 10}}
                              >
                                <i className="fa-solid fa-caret-up" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                              <button
                                className="btn-sort"
                                // onClick={() => setSortType("clicks-desc")}
                                style={{backgroundColor: 'transparent', border: 'none', height: 10, marginBottom: 10}}

                              >
                                <i className="fa-solid fa-caret-down" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                            </div>
                          </div>
                        </th>
                         
                        <th style={{...thStyle, backgroundColor:"#0F9D58"}}>
                           <div className="d-flex justify-content-between align-items-center">
                            <span>Click</span>
                            <div className="d-flex flex-column">
                              <button
                                className="btn-sort"
                                // onClick={() => setSortType("cost-asc")}
                                 style={{backgroundColor: 'transparent', border: 'none', height: 10}}
                              >
                                <i className="fa-solid fa-caret-up" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                              <button
                                className="btn-sort"
                                // onClick={() => setSortType("cost-desc")}
                                style={{backgroundColor: 'transparent', border: 'none', height: 10, marginBottom: 10}}

                              >
                                <i className="fa-solid fa-caret-down" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                            </div>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {lineData[0]?.lineData?.broadcast.map((row, idx) => (
                          <tr key={idx} style={{backgroundColor: idx % 2 === 0 ? "#fff" : "#E6E6E6"}} 
                          >
                            <td style={tdStyle}>{idx+1}</td>
                            <td style={tdStyle}>{row.id}</td>
                             <td style={tdStyle}>{row.startDate} - {row.startTime}</td>
                            <td style={tdStyle}>{row.name.slice(0,30)}</td>
                            <td style={tdStyle}>{row.delivered}</td>
                            <td style={tdStyle}>{row.openCount}</td>
                            <td style={tdStyle}>{row.uniqueClick}</td>
                          </tr>
                          )
                      )}
                    </tbody>
                  </table>
                </div>    
                <div style={{fontSize: 40, fontWeight: 'bold', textAlign: 'left', marginLeft: 30, marginTop: 10}}>Coupon</div>
                 <div style={{ overflowX: "auto", width: "100%" }}>
                  <table border="1" style={{ marginTop: 20, width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr>
                        <th style={thStyle}>No.</th>
                        <th style={thStyle}>Status</th>
                        <th style={thStyle}>Coupon Name</th>
                         <th style={{...thStyle, backgroundColor:"#4285F4"}}>
                          <div className="d-flex justify-content-between align-items-center">
                            <span>Number of Use</span>
                            <div className="d-flex flex-column">
                              <button
                                className="btn-sort"
                                 style={{backgroundColor: 'transparent', border: 'none', height: 10}}
                              >
                                <i className="fa-solid fa-caret-up" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                              <button
                                className="btn-sort"
                                style={{backgroundColor: 'transparent', border: 'none', height: 10, marginBottom: 10}}
                              >
                                <i className="fa-solid fa-caret-down" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                            </div>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {lineData[0]?.lineData?.coupon.map((row, idx) => (
                          <tr key={idx} style={{backgroundColor: idx % 2 == 0 ? "#fff" : "#E6E6E6"}} 
                          >
                            <td style={tdStyle}>{idx+1}</td>
                            <td style={tdStyle}>{row.status}</td>
                            <td style={tdStyle}>{row.title.slice(0,30)}</td>
                             <td style={tdStyle}>{row.numberOfUse}</td>
                          </tr>
                          )
                      )}
                    </tbody>
                  </table>
                </div>  
                </div>
                )}

        </div>
</div>
  );
}
const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  borderRadius: 16,
  boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
  backgroundColor: "#fff",
  tableLayout: "auto",
  marginTop: 10
};
const thStyle = {
  padding: "14px 16px",
  textAlign: "center",
  background: "linear-gradient(135deg, #009900 0%, #06C755 100%)",
  color: "#fff",
  fontSize: 20,
  fontWeight: 600,
  letterSpacing: "0.5px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
};

const tdStyle = {
  padding: "12px 14px",
  textAlign: "center",
  border: "1px solid #e5e7eb",
  fontSize: 18,
  color: "#333",
  backgroundColor: "#fff",
  cursor: "pointer",
  whiteSpace: "nowrap", 
};


